import { useSelector } from 'react-redux'
import { Box, CircularProgress } from '@mui/material'
import { ListResponseType } from 'services/types'
import { TBakersInsight } from 'types/models/BakersInsights'
import { RECOMMENDATION_INSIGHT } from 'types/models/BakersRecommendations'
import { TModuleKey } from 'store/slices/insightsTabsSlice'
import { selectTabs } from 'store/selectors/insightsTabsSliceSelectors'
import { Container } from '../../../../../Shipment/pages/IncomingDeliveriesDetails/components/ConsistencyResult/ConsistencyResult.styled'
import { CardTitle } from '../../../../../../components'
import { RecommendationInsightCard } from './recommendationInsightCard'
import * as sxStyles from '../../AnalyticsDetails.styled'

interface IInsightsSectionProps {
  insights: ListResponseType<TBakersInsight>
  isInsightLoading: boolean
  selectedDeliveryId: string
  moduleKey: TModuleKey
}

export const InsightsSection = ({
  insights,
  isInsightLoading,
  selectedDeliveryId,
  moduleKey,
}: IInsightsSectionProps) => {
  const tabs = useSelector(selectTabs(moduleKey, selectedDeliveryId))
  const isBothOpen = tabs.insights && tabs.recommendations
  const maxHeight = isBothOpen ? 310 : 'calc(100vh - 200px)'

  return (
    <Box sx={sxStyles.sectionContainer}>
      <Container>
        <Box px="16px">
          <CardTitle title="Insights" />
        </Box>
        <Box
          sx={{
            ...sxStyles.expandableBox,
            maxHeight,
          }}
        >
          {insights ? (
            insights.results.map((insight) => (
              <RecommendationInsightCard
                key={insight.guid}
                cardData={insight}
                type={RECOMMENDATION_INSIGHT.insight}
                selectedDeliveryId={selectedDeliveryId}
              />
            ))
          ) : isInsightLoading ? (
            <CircularProgress color="primary" />
          ) : null}
        </Box>
      </Container>
    </Box>
  )
}
